<template>
  <div style="height: 100%;overflow: auto;">
    <Nav :msg="msg" :nav="nav"></Nav>
    <div class="mt-20">
      <el-table :data="list" border stripe row-style="max-height:100px;">
        <el-table-column label="ID" prop="id" width="50px"></el-table-column>
        <el-table-column label="标题" prop="title"></el-table-column>
        <el-table-column label="显示状态" prop="is_show">
          <template v-slot="scope">
            <el-tag type="success" size="small" v-if="scope.row.is_show==0">下架中</el-tag>
            <el-tag type="danger" size="small" v-if="scope.row.is_show==1">上架中</el-tag>
            <template v-if="scope.row.is_show ==0">
              <el-popconfirm title="确定上架？" @confirm="show(scope.row.id,'1')">
                <el-button slot="reference" type="danger" size="mini" class="ml-10" style="margin-left: 10px;">上架
                </el-button>
              </el-popconfirm>
            </template>
            <template v-if="scope.row.is_show ==1">
              <el-popconfirm title="确定下架？" @confirm="show(scope.row.id,'0')">
                <el-button type="success" size="mini" slot="reference" class="ml-10" style="margin-left: 10px;">下架
                </el-button>
              </el-popconfirm>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="排序" prop="sort"></el-table-column>
        <el-table-column label="创建时间" prop="addtime"></el-table-column>
        <!--        <el-table-column label="操作时间" prop="lasttime"></el-table-column>-->
        <el-table-column label="操作" width="220px">
          <template v-slot="scope">
            <el-button type="primary" @click="page_edit(scope.row.id)" size="small" style="margin-right: 10px;">编辑
            </el-button>
            <el-button type="success" @click="form_show(scope.row.id,scope.row.form_content)" size="small"
                       style="margin-right: 10px;">表单
            </el-button>
            <el-popconfirm title="确认删除？" @confirm="del(scope.row.id)">
              <el-button type="danger" size="small" slot="reference">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="height: 60px;"></div>
    <LayerPage :total="total" :currentPage="page" @change="page_change"></LayerPage>
    <LayerPop title="添加/编辑分类" @close="vue_pop_show_hide" v-if="is_pop">
    </LayerPop>
  </div>
</template>

<script>
import Nav from "@/components/nav";
import LayerPage from "@/components/layer-page";
import LayerPop from "@/components/layer-pop";
export default {
name: "sort",
  components:{Nav,LayerPage,LayerPop},
  data(){
    return{
      msg: 'one_page_sort',
      nav:[
        {name:'单页列表',path:'one_page'},
        {name:'添加 / 编辑单页',path:'one_page_detail'},
        {name:'单页分类',path:'one_page_sort'},
      ],
      list:[],
      page:1,
      total:0,
      is_pop:false,
    }
  },
  mounted:async function (){
    try{
      await this.get_list();
    }catch (e){
      console.log(e);
      return false;
    }
  },
  methods:{
    get_list:async function (){
      this.is_load = true;
      this.$_showLoading();
      let res = await this.$_api.page('get_sortlist', {});
      this.is_load = false;
      this.$_hideLoading();
      this.list = res.list;
      this.total = res.total;
    },
  }
}
</script>

<style scoped>

</style>